import { services } from '../Functions'
import { FilterElement } from './FilterElement'

const FilterSections = (props) => {
  return (
    <>
      {services.map(({ id, ...service }) => {
        const flagAbilitazioneAuto = props?.flagAbilitazioneAuto
        const shouldRenderElement = id !== 'car' || flagAbilitazioneAuto

        if (!shouldRenderElement) return null

        return (
          <FilterElement
            key={id}
            selectedFilters={props?.[id]?.selectedFilters}
            options={props?.[id]?.optionsFilters}
            service={service}
            inputValues={props?.[id]?.inputValues}
            inputRimborso={props?.[id]?.inputRimborso}
            inputNoRimborso={props?.[id]?.inputNoRimborso}
            radius={props?.[id]?.radius}
            logicaCameraNonInPenale={props?.[id]?.logicaCameraNonInPenale}
            soloCamereNonInPenale={props?.[id]?.soloCamereNonInPenale}
            tolleranzaGiorniPenale={props?.[id]?.tolleranzaGiorniPenale}
            servicePriority={props?.[id]?.servicePriority}
            flagAbilitazione={props?.[id]?.flagAbilitazione}
            flagAbilitazioneAuto={props?.[id]?.flagAbilitazioneAuto}
            trainFarePriority={props?.[id]?.trainFarePriority}
          />
        )
      })}
    </>
  )
}

export default FilterSections
